import { h } from 'preact';
import icon from '../assets/images/icon-info.svg'

const Note = ({children}) => {
    return <p style={{fontWeight:300, paddingLeft:26,color:'#5A626C', background: `url(${icon}) no-repeat left center`}}>{children}</p>
}
export default Note;


// WEBPACK FOOTER //
// ./components/Note.js